<template>
  <div>
    <Diccionario :id_unit="this.idUnidad"/>
    <CardProgreso
      :title="currentUnit.title"
      :description="currentUnit.description"
      :image="require('@/assets/images/unit/menu/' + currentUnit.icon)"
      :progress="this.progressUnit"
    />
    <v-container grid-list-md pa-0 mt-3 fluid>
      <v-alert ref="alert" v-model="alert.show" :color="alert.color">{{ alert.message }}</v-alert>
      <v-progress-circular v-if="loading" :size="50" color="primary" indeterminate></v-progress-circular>
      <v-layout row wrap v-if="!loading">

        <CardGramaticaComplete v-for="gramatica in cardGramatica"
          :style="!gramatica.bloqueada && gramatica.completada || 'display: none;'"
          :key="`GramaticaComple-${gramatica.id}`"
          :urlIds="`${gramatica.id_unidad}/${gramatica.id_gramatica}`"
          :titulo="gramatica.titulo"
          :descripcion="gramatica.descripcion"/>

        <CardGramatica  v-for="gramatica in cardGramatica"
        :style="!gramatica.bloqueada && !gramatica.completada || 'display: none;'"
        @click="goDetail(gramatica)"
        :key="`Gramatica-${gramatica.id}`"
        :titulo="gramatica.titulo"
        :descripcion="gramatica.descripcion"/>

        <CardDeshabilitada v-for="gramatica in cardGramatica"
        :style="gramatica.bloqueada || 'display: none;'"
        :key="`GramaticaDesha-${gramatica.id}`"
        :title="gramatica.titulo"
        :descripcion="gramatica.descripcion"/>

        <CardPracticaComplete v-for="practica in cardPractica"
          :style="!practica.bloqueada || 'display: none;'"
          :key="`practica-${practica.id}`"
          :title="practica.title"
          :color="practica.color"
          :router="`${practica.router}/${idUnidad}`"/>

        <CardDeshabilitada v-for="practica in cardPracticaDisabled"
          :style="practica.bloqueada || 'display: none;'"
          :key="`practicaDesha-${practica.id}`"
          :practica="true"
          :title="`Práctica ${practica.title}`" />
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import CardProgreso from '../../components/Unidad/CardProgreso'
import CardGramatica from '../../components/Unidad/CardGramatica'
import CardGramaticaComplete from '../../components/Unidad/CardGramaticaComplete'
import CardPracticaComplete from '../../components/Unidad/CardPracticaComplete'
import CardDeshabilitada from '../../components/Unidad/CardDesabilitada'
import { storeFirebase } from '../../store/firebase'

export default {
  components: {
    CardGramatica,
    CardProgreso,
    CardDeshabilitada,
    CardGramaticaComplete,
    CardPracticaComplete
  },
  props: ['idUnidad'],
  data () {
    return {
      loading: true,
      alert: {
        show: false,
        color: '',
        message: ''
      },
      progressUnit: 0,
      progressUser: {},
      finalProgress: {
        numberGrammar: 0,
        sumaValGrammar: 0,
        numberPractice: 3,
        sumaValPractice: 0
      }
    }
  },
  created () {
    this.loadGrammar()
  },
  computed: {
    cardGramatica () {
      const gramaticas = storeFirebase.getters.loadedGrammar
      const unitVal = 'unit_' + this.idUnidad
      const progressGrammar = this.progressUser.grammar[unitVal]
      if (!progressGrammar[0].grammarisFull) {
        const updateGrammar = [];
        for(let index in gramaticas) {
          const data = gramaticas[index]
          const newIndex = data.id_gramatica
          const grammVAl = `{"grammar_${newIndex}": 0, "lessonsIsFull": false}`
          const grammFinal = JSON.parse(grammVAl)
          updateGrammar.push(grammFinal);
          if(Number(index) > 0){
            data.bloqueada = true
            gramaticas[index] = data
          }
        }
        updateGrammar.unshift(
           {
             "grammarisFull": true,
             'totalGrammar': gramaticas.length
           }
        )
        this.progressUser.grammar[unitVal] = updateGrammar
      } else {
        let bloquear = false;
        let sumaValGrammar = 0
        for(let index in gramaticas) {
          const data = gramaticas[index]
          const newIndex = data.id_gramatica
          const grammVAl = `grammar_${newIndex}`
          const indexProgress = (Number(index) + 1)
          const grammFinal = progressGrammar[indexProgress]
          sumaValGrammar = sumaValGrammar + grammFinal[grammVAl]
          if (Number(index) === 0 && grammFinal[grammVAl] < 100 ) {
            bloquear = true;
            continue
          } else if (!bloquear) {
            if (Number(index) === 0 && grammFinal[grammVAl] === 100) {
              data.completada = true
              gramaticas[index] = data
              continue
            } else {
              if (grammFinal[grammVAl] < 100) {
                bloquear = true;
                continue
              } else {
                data.completada = true
                gramaticas[index] = data
                continue
              }
            }
          }
          if (bloquear) {
            data.bloqueada = true
            gramaticas[index] = data
          }
        }
        this.finalProgress.numberGrammar = progressGrammar[0].totalGrammar
        this.finalProgress.sumaValGrammar = sumaValGrammar
      }
      return gramaticas
    },
    cardPractica () {
      const practice = storeFirebase.getters.loadedPractice
      const unitVal = 'unit_' + this.idUnidad
      const progressPractice = this.progressUser.practice[unitVal]
      let bloquear = false;
      let sumaValPractice = 0
      for(let index in practice) {
        const data = practice[index]
        const dataPractice = progressPractice[index]
        const valPractice = dataPractice[data.nombre]
        sumaValPractice = sumaValPractice + Number(valPractice)
        if (Number(index) === 0 && valPractice < 100) {
          bloquear = true
          continue
        } else if (!bloquear) {
          if(Number(index) === 0 && valPractice === 100) {
            bloquear = false
          } else {
            if (valPractice < 100) {
              practice[index].bloqueada = false
              bloquear = true
              continue
            } else {
              practice[index].bloqueada = false
            }
          }
        }
        if (bloquear) {
          practice[index].bloqueada = true
        }
      }
      this.finalProgress.sumaValPractice = sumaValPractice
      const sumaNumber = this.finalProgress.numberGrammar + this.finalProgress.numberPractice
      const sumaVal = this.finalProgress.sumaValGrammar + this.finalProgress.sumaValPractice
      const totalProgressUnit = sumaVal / sumaNumber
      this.progressUser.units[unitVal] = totalProgressUnit
      this.updateUserProgress(this.progressUser)
      return practice
    },
    cardPracticaDisabled () {
      const practiceDisabled = storeFirebase.getters.loadedPractice.filter( val => val.bloqueada )
      return practiceDisabled
    },
    currentUnit () {
      const currentCardUnit = {
        title: `UNIDAD ${this.idUnidad}`,
        description: '카드 지우개',
        icon: 'mainImage.png'
      }
      const units = storeFirebase.getters.loadedUnits
      const id_unidad = Number(this.idUnidad)
      const unit = units.find(unit => unit.id_unidad === id_unidad)
      if (unit !== null && unit !== undefined) {
        this.progressUser = storeFirebase.getters.userProgress
        const unitVal = 'unit_' + this.idUnidad
        this.progressUnit = this.progressUser.units[unitVal]
        return unit
      }
      return currentCardUnit
    }
  },
  methods: {
    goDetail (gramaticaText) {
      let gramatica = gramaticaText
      const routerGrammar = `/gramatica/${gramatica.id_unidad}/${gramatica.id_gramatica}/gramaticaDash`
      this.$router.push(routerGrammar)
    },
    loadGrammar () {
      const idUnidad = Number(this.idUnidad)
      if (!isNaN(idUnidad)) {
        storeFirebase.dispatch('loadUserProgress', {})
        storeFirebase.dispatch('loadGrammar', { id_unidad: idUnidad }).then(() => {
          setTimeout(() => {
            this.loading = false
          }, 2500)
        })
      } else {
        this.loading = false
        this.alert.color = 'error'
        this.alert.message = 'Debes Seleccionar una Unidad'
        this.alert.show = true
      }
    },
    updateUserProgress(newUserProgress) {
      storeFirebase.dispatch('updateUserProgress', newUserProgress)
    }
  }
}
</script>
